<div class="container-space-between">
  <app-page-title
    [goBackRoute]="routingEnum.ADMIN_RULESETS"
    [goBackRouteState]="resourceType ? { selectedTabResourceType: resourceType } : undefined"
    [tag]="element()?.recordState === recordStateEnum.ARCHIVED ? translations.archived : ''"
    [title]="element()?.name ?? translations.title"
    [backText]="translations.titleBackText"
  ></app-page-title>

  @if (hasRulesetsWriteAccess && !isLoading()) {
    <app-button-group>
      <app-more-actions-buttons
        (clickLabel)="onEdit()"
        (reloadData)="loadData($event)"
        [isArchiveEnabled]="true"
        [isDeleteEnabled]="true"
        [disabledMainButton]="element()?.recordState !== recordStateEnum.ACTIVE"
        [element]="element()"
        [service]="rulesetsService"
        [label]="translations.editLabel"
        labelIcon="edit"
      ></app-more-actions-buttons>
    </app-button-group>
  }
</div>

@if (isLoading()) {
  <app-loader></app-loader>
} @else {
  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z0 section-box" [expanded]="true">
      <mat-expansion-panel-header class="section-header">
        <mat-panel-title class="section-title">
          <h3>{{ mainInformationText }}</h3>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row-container">
        <div class="row row-4">
          <div class="item">
            <p class="details-label" i18n="@@ruleset-details.rulesetfor">Ruleset for</p>
            <app-value-and-copy-button
              valueClass="details-value"
              [value]="resourceTypePlural"
            ></app-value-and-copy-button>
          </div>
          <div class="item">
            <p class="details-label" i18n="@@shared.description">Description</p>
            <app-value-and-copy-button
              valueClass="details-value"
              [value]="element().description"
            ></app-value-and-copy-button>
          </div>
        </div>
      </div>
      <app-record-details [element]="element()" [columns]="4"></app-record-details>
    </mat-expansion-panel>
  </mat-accordion>
  <br />
  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z0 section-box" [expanded]="true">
      <mat-expansion-panel-header class="section-header">
        <mat-panel-title class="section-title">
          <h3 i18n="@@shared.criteria">Criteria</h3>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (conditionFormGroup) {
        <div class="row-container">
          <div class="row row-1">
            <div class="item">
              <app-ruleset-criteria
                [formGroup]="conditionFormGroup"
                [propertyOptions]="propertyOptions"
                [locationTypeOptions]="locationTypeOptions()"
                [countryOptions]="countryOptions()"
                [locationOptions]="locationOptions()"
                [isReadOnly]="true"
              ></app-ruleset-criteria>
            </div>
          </div>
        </div>
      } @else {
        <p class="dark-gray no-margin">
          <small i18n="@@ruleset.nocriteria">No criteria has been set for this ruleset.</small>
        </p>
      }
    </mat-expansion-panel>
  </mat-accordion>
  <br />
  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z0 section-box" [expanded]="true">
      <mat-expansion-panel-header class="section-header">
        <mat-panel-title class="section-title">
          <h3 i18n="@@shared.expectations">Expectations</h3>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row-container">
        <app-expectation-group
          [expectationsFormArray]="expectationFormGroup"
          [isReadOnly]="true"
          [valueOptions]="documentTypeOptions()"
        ></app-expectation-group>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
}
